import React from "react";
import { graphql } from "gatsby";

import WithI18next from "../../components/WithI18next";
import Layout from "../../components/Layout";
import LearnArticleLayout from "../../layouts/LearnArticleLayout";

const LearnTemplate = ({ data, pageContext, location, lang }) => {
  return (
    <Layout
      title={data.wpPost.seo.title}
      description={data.wpPost.seo.metaDesc}
      imageMetaTag={data.wpPost.featuredImage.node.localFile.publicURL}
    >
      <LearnArticleLayout
        data={data}
        lang={lang}
        currentUrl={location.href}
        articleTopic={pageContext.topic}
      />
    </Layout>
  );
};

export default WithI18next()(LearnTemplate);

export const query = graphql`
  query (
    $id: Int!
    $wpLocale: String!
    $wpGlobalConfig: String!
    $categories: [String]
  ) {
    wpPost(databaseId: { eq: $id }, language: { locale: { eq: $wpLocale } }) {
      title
      content
      excerpt
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          caption
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1200, layout: CONSTRAINED)
            }
            publicURL
          }
        }
      }
      categories {
        nodes {
          slug
          wpParent {
            node {
              slug
            }
          }
        }
      }
      seo {
        canonical
        metaDesc
        title
      }
    }
    relatedArticles: allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { slug: { in: $categories } } } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        databaseId: { ne: $id }
      }
      sort: { order: DESC, fields: date }
      limit: 3
    ) {
      nodes {
        title
        excerpt
        slug
        date(formatString: "MMMM DD, YYYY")
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 690, layout: CONSTRAINED)
              }
            }
          }
        }
        categories {
          nodes {
            slug
            wpParent {
              node {
                slug
              }
            }
          }
        }
        tags {
          nodes {
            name
            slug
          }
        }
      }
    }
    subscribeBannerContent: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        acfPartials: { pPartialId: { eq: "learn-subscribe-banner" } }
      }
    ) {
      edges {
        node {
          acfPartials {
            pHeading
            pIntroHeading
            pContent
            pButtonText
            pIcon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;
